import z from 'zod';
import { UrlSchema } from '@/core/data/schemas/url';
import { EventSchema, RawEventSchema } from '@/events/events/event.schema';
import {
	PerformerSchema,
	RawPerformerSchema,
} from '@/events/performers/performer.schema';
import { AssetSchema } from '../events/assets/asset.schema';
import { RawVenueSchema, VenueSchema } from '../events/venues/venue.schema';

export const RawSearchResultsSchema = z.object({
	display_groups: z
		.array(
			z.object({
				display_name: z.string(),
				slug: z.string(),
				sort_order: z.number(),
			}),
		)
		.optional(),
	events: z.array(RawEventSchema).optional(),
	performers: z.array(RawPerformerSchema).optional(),
	venues: z.array(RawVenueSchema).optional(),
});

export type GetSearchResultsResponse = z.infer<typeof RawSearchResultsSchema>;

export const SearchResultsSchema = z.object({
	events: z.array(EventSchema),
	performers: z.array(PerformerSchema),
	venues: z.array(VenueSchema),
});

export type SearchResults = z.infer<typeof SearchResultsSchema>;

export const SearchResultSchema = z.object({
	assets: AssetSchema.optional(),
	date: z.date().optional(),
	emoji: z.string().optional(),
	price: z.string().optional(),
	subtitle: z.string().optional(),
	title: z.string(),
	url: UrlSchema,
});

export type SearchResult = z.infer<typeof SearchResultSchema>;
